import { StyledComponent } from '../../../types/styledComponent'
import * as Styled from '../styles'
import { Variant } from '../types/variant'

export const variantToComponent: Record<Variant, StyledComponent> = {
  display: Styled.Display,
  h1: Styled.TextH1,
  h2: Styled.TextH2,
  h3: Styled.TextH3,
  h4: Styled.TextH4,
  bodyLG: Styled.TextBodyLG,
  bodyMD: Styled.TextBodyMD,
  bodySM: Styled.TextBodySM,
}
